/**
 * Error severity levels for categorization and handling
 * Used across ErrorBoundary, logging, and error handling
 */
export enum ErrorSeverity {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

/**
 * Error category types for classification
 * Used across ErrorBoundary and error handling contexts
 */
export enum ErrorCategory {
  NETWORK = "NETWORK",
  AUTHENTICATION = "AUTHENTICATION",
  AUTHORIZATION = "AUTHORIZATION",
  VALIDATION = "VALIDATION",
  BUSINESS_LOGIC = "BUSINESS_LOGIC",
  SYSTEM = "SYSTEM",
  UNKNOWN = "UNKNOWN",
}

/**
 * Log severity levels matching backend schema
 * Maps to DiagnosticLog.severity enum
 */
export enum LogSeverity {
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
  CRITICAL = "CRITICAL",
}

/**
 * Log source types matching backend schema
 * Maps to DiagnosticLog.source enum
 */
export enum LogSource {
  FRONTEND_UI = "frontend-ui-service",
  BACKEND_API = "backend-api-service",
  DB_SQL = "db-sql-service",
}
